import styled from "styled-components";
import { breakpoint, color, snap, typeStyle, units } from "@m/alchemy-theme";
export const EmptyState = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: ${units(1.5)};
  @media (min-width: ${breakpoint("medium")}px) {
    padding: ${units(4)};
  }
`;
export const IconWrapper = styled.div `
  margin: 0 0 ${units(1.5)};
  @media (min-width: ${breakpoint("medium")}px) {
    margin: 0 0 ${units(3)};
  }
`;
export const Message = styled.strong `
  ${typeStyle("subHeaderM")};
  @media (min-width: ${breakpoint("medium")}px) {
    ${typeStyle("headerM")};
  }
  color: ${color("typeBody")};
  margin-bottom: ${units(1.5)};
  width: 100%; /* IE11 */
  max-width: ${snap(768)};
`;
export const DetailsWrapper = styled.div `
  ${typeStyle("bodyS")};
  @media (min-width: ${breakpoint("medium")}px) {
    ${typeStyle("bodyL")};
  }
  color: ${color("typeBody")};
  width: 100%; /* IE11 */
  max-width: ${snap(768)};
`;
